import { render, staticRenderFns } from "./LayoutAccount.vue?vue&type=template&id=097f5b83"
import script from "./LayoutAccount.vue?vue&type=script&lang=js"
export * from "./LayoutAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports